(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beneficioshome"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root) => {
      const benefits = root.querySelectorAll('[data-caffi-benefit]');
      if (!benefits.length) return;

      root.classList.add('cb-js');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        benefits.forEach((benefit) => benefit.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.2 });

      benefits.forEach((benefit) => observer.observe(benefit));
    };

    const start = () => {
      document.querySelectorAll('[data-caffi-benefits]').forEach(initialise);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialise(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blogcards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root) => {
      if (!root || root.dataset.caffiInitialised === 'true') return;

      root.dataset.caffiInitialised = 'true';
      const cards = root.querySelectorAll('[data-caffi-card]');

      if (!cards.length) return;

      root.classList.add('caffi-science-blog--js');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        cards.forEach((card) => card.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12 });

      cards.forEach((card) => observer.observe(card));
    };

    const start = () => {
      document.querySelectorAll('[data-caffi-science-blog]').forEach(initialise);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector ? event.target.querySelector('[data-caffi-science-blog]') : null;
      initialise(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caffi-stats"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const duration = 1400;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setFinalValue = (counter) => {
      counter.textContent = counter.dataset.target || '0';
      counter.dataset.caffiAnimated = 'true';
    };

    const animateCounter = (counter) => {
      if (counter.dataset.caffiAnimated === 'true') return;

      const rawTarget = counter.dataset.target || '0';
      const target = Number(rawTarget.replace(',', '.'));

      if (!Number.isFinite(target) || reducedMotion) {
        setFinalValue(counter);
        return;
      }

      counter.dataset.caffiAnimated = 'true';

      const decimals = (rawTarget.replace(',', '.').split('.')[1] || '').length;
      const startedAt = performance.now();

      const update = (now) => {
        const progress = Math.min((now - startedAt) / duration, 1);
        const easedProgress = 1 - Math.pow(1 - progress, 3);
        const value = target * easedProgress;

        counter.textContent = decimals > 0
          ? value.toFixed(decimals)
          : Math.round(value);

        if (progress < 1) {
          window.requestAnimationFrame(update);
        } else {
          counter.textContent = rawTarget;
        }
      };

      window.requestAnimationFrame(update);
    };

    const initCounters = (root) => {
      const counters = root.querySelectorAll('[data-caffi-counter]');

      if (!('IntersectionObserver' in window)) {
        counters.forEach(animateCounter);
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          animateCounter(entry.target);
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.35 });

      counters.forEach((counter) => observer.observe(counter));
    };

    const start = () => initCounters(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initCounters(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comogrid"] && !Shopify.designMode) return;
  try {
    

(() => {

  const init = (scope) => {

    const sections = [];


    if (
      scope.matches &&
      scope.matches('[data-cgc-flow]')
    ) {

      sections.push(scope);

    }


    scope
      .querySelectorAll('[data-cgc-flow]')
      .forEach(section => sections.push(section));


    sections.forEach(section => {


      if (
        section.dataset.cgcReady === 'true'
      ) {

        return;

      }


      section.dataset.cgcReady = 'true';


      const reveals =
        section.querySelectorAll(
          '.cgc-flow__reveal'
        );


      if (
        !('IntersectionObserver' in window)
      ) {

        section.classList.add(
          'is-visible'
        );


        reveals.forEach(item =>

          item.classList.add(
            'is-visible'
          )

        );


        return;

      }


      const observer =
        new IntersectionObserver(
          entries => {

            entries.forEach(entry => {

              if (!entry.isIntersecting) {
                return;
              }


              section.classList.add(
                'is-visible'
              );


              reveals.forEach(item =>

                item.classList.add(
                  'is-visible'
                )

              );


              observer.disconnect();

            });

          },
          {
            threshold: 0.15
          }
        );


      observer.observe(section);

    });

  };


  init(document);


  document.addEventListener(
    'shopify:section:load',
    event => init(event.target)
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root) => {
      if (!root || root.dataset.ccReady === 'true') return;

      const items = root.querySelectorAll('[data-cc-reveal]');
      if (!items.length) return;

      root.dataset.ccReady = 'true';
      root.classList.add('cc-js');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.14 });

      items.forEach((item) => observer.observe(item));
    };

    const start = () => {
      document.querySelectorAll('[data-caffi-comparison]').forEach(initialise);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialise(event.target.querySelector('[data-caffi-comparison]') || event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqhome"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const init = (root) => {
      const section = root.matches?.('[data-caffi-faq]') ? root : root.querySelector?.('[data-caffi-faq]');
      if (!section || section.dataset.cfqInit === 'true') return;
      section.dataset.cfqInit = 'true';

      const single = section.dataset.single === 'true';
      const items = [...section.querySelectorAll('.cfq-item')];

      const close = (item) => {
        item.classList.remove('is-open');
        if (reduced) {
          item.open = false;
          return;
        }
        setTimeout(() => { if (!item.classList.contains('is-open')) item.open = false; }, 320);
      };

      const open = (item) => {
        item.open = true;
        requestAnimationFrame(() => item.classList.add('is-open'));
      };

      items.forEach((item) => {
        const summary = item.querySelector('summary');
        summary.addEventListener('click', (e) => {
          e.preventDefault();
          const isOpen = item.classList.contains('is-open');
          if (single) items.forEach((other) => { if (other !== item && other.classList.contains('is-open')) close(other); });
          isOpen ? close(item) : open(item);
        });
      });
    };

    const boot = () => document.querySelectorAll('[data-caffi-faq]').forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (e) => init(e.target));
    document.addEventListener('shopify:block:select', (e) => {
      const item = e.target.closest?.('.cfq-item');
      if (item && !item.classList.contains('is-open')) {
        item.open = true;
        item.classList.add('is-open');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gridviral"] && !Shopify.designMode) return;
  try {
    

(() => {

  const initSection = (scope) => {

    const roots = [];


    if (
      scope.matches &&
      scope.matches('[data-caffi-viral]')
    ) {

      roots.push(scope);

    }


    scope
      .querySelectorAll('[data-caffi-viral]')
      .forEach(root => roots.push(root));


    roots.forEach(root => {


      if (
        root.dataset.caffiViralReady === 'true'
      ) {

        return;

      }


      root.dataset.caffiViralReady = 'true';


      const reveals =
        root.querySelectorAll(
          '.caffi-viral__reveal'
        );


      if (
        'IntersectionObserver' in window
      ) {

        const observer =
          new IntersectionObserver(
            (entries, currentObserver) => {

              entries.forEach(entry => {

                if (!entry.isIntersecting) {
                  return;
                }


                reveals.forEach(item =>
                  item.classList.add(
                    'is-visible'
                  )
                );


                currentObserver.disconnect();

              });

            },

            {
              threshold:
                .12
            }
          );


        observer.observe(root);

      }

      else {

        reveals.forEach(item =>
          item.classList.add(
            'is-visible'
          )
        );

      }



      const wrap =
        root.querySelector(
          '[data-video-wrap]'
        );


      const button =
        root.querySelector(
          '[data-video-toggle]'
        );


      if (
        wrap &&
        button
      ) {

        const video =
          wrap.querySelector(
            'video'
          );


        if (video) {

          button.addEventListener(
            'click',
            () => {

              if (video.paused) {

                video.play();

              }

              else {

                video.pause();

              }

            }
          );

        }

      }

    });

  };


  initSection(document);


  document.addEventListener(
    'shopify:section:load',
    event =>
      initSection(event.target)
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["innerbannerr"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCaffiCaffinnerCircle = (root) => {
      if (root.dataset.caffiCircleReady === 'true') return;
      root.dataset.caffiCircleReady = 'true';

      const content = root.querySelector('[data-caffi-circle-reveal]');
      if (!content || !('IntersectionObserver' in window)) {
        if (content) content.classList.add('is-visible');
        return;
      }

      root.classList.add('is-ready');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.18 });

      observer.observe(content);
    };

    const initAllCaffiCaffinnerCircles = () => {
      document.querySelectorAll('[data-caffi-caffinner-circle]').forEach(initCaffiCaffinnerCircle);
    };

    initAllCaffiCaffinnerCircles();
    document.addEventListener('shopify:section:load', initAllCaffiCaffinnerCircles);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["items"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobile = window.matchMedia('(max-width: 749px)');

    const init = (root) => {
      const section = root.matches?.('[data-caffi-benefits]') ? root : root.querySelector?.('[data-caffi-benefits]');
      if (!section || section.dataset.cbnInit === 'true') return;
      section.dataset.cbnInit = 'true';

      const track = section.querySelector('[data-cbn-track]');
      const items = [...section.querySelectorAll('[data-cbn-item]')];
      const dots = [...section.querySelectorAll('.cbn-dot')];

      /* Aparición al hacer scroll */
      section.classList.add('cbn-js');
      if (reduced || !('IntersectionObserver' in window)) {
        items.forEach((i) => i.classList.add('is-visible'));
      } else {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          });
        }, { threshold: 0.2 });
        items.forEach((i) => io.observe(i));
      }

      if (!track || !dots.length) return;

      /* Puntitos sincronizados con el carrusel */
      const currentIndex = () => {
        const left = track.scrollLeft;
        let best = 0;
        let bestDist = Infinity;
        items.forEach((item, i) => {
          const d = Math.abs(item.offsetLeft - track.offsetLeft - left - 16);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return best;
      };

      const setActive = (idx) => dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));

      const goTo = (idx) => {
        const item = items[idx];
        if (!item) return;
        track.scrollTo({ left: item.offsetLeft - track.offsetLeft - 16, behavior: reduced ? 'auto' : 'smooth' });
      };

      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => setActive(currentIndex()));
      }, { passive: true });

      dots.forEach((dot) => dot.addEventListener('click', () => {
        goTo(Number(dot.dataset.index));
        restart();
      }));

      /* Autoplay solo en mobile; se pausa cuando la persona toca */
      let timer;
      const autoplay = section.dataset.autoplay === 'true' && !reduced;
      const speed = Number(section.dataset.speed) || 3000;

      const stop = () => clearInterval(timer);
      const start = () => {
        stop();
        if (!autoplay || !mobile.matches) return;
        timer = setInterval(() => {
          const next = (currentIndex() + 1) % items.length;
          goTo(next);
        }, speed);
      };
      const restart = () => { stop(); start(); };

      track.addEventListener('touchstart', stop, { passive: true });
      track.addEventListener('touchend', () => setTimeout(start, 2500), { passive: true });
      mobile.addEventListener?.('change', restart);
      start();
    };

    const boot = () => document.querySelectorAll('[data-caffi-benefits]').forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquueestat"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const format = (n, el) => (el.dataset.format === 'true' ? Math.round(n).toLocaleString('es-AR') : String(Math.round(n)));

    const count = (el) => {
      if (el.dataset.done === 'true') return;
      el.dataset.done = 'true';
      const target = Number(el.dataset.target) || 0;

      if (reduced) {
        el.textContent = format(target, el);
        return;
      }

      const duration = 1600;
      const start = performance.now();
      const tick = (now) => {
        const p = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        el.textContent = format(target * eased, el);
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };

    const init = (root) => {
      const section = root.matches?.('[data-caffi-ms]') ? root : root.querySelector?.('[data-caffi-ms]');
      if (!section || section.dataset.cmsInit === 'true') return;
      section.dataset.cmsInit = 'true';

      const counters = [...section.querySelectorAll('[data-cms-counter]')];
      counters.forEach((el) => { el.textContent = reduced ? format(Number(el.dataset.target) || 0, el) : '0'; });

      if (!('IntersectionObserver' in window)) {
        counters.forEach(count);
        return;
      }

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          count(e.target);
          io.unobserve(e.target);
        });
      }, { threshold: 0.4 });

      counters.forEach((el) => io.observe(el));
    };

    const boot = () => document.querySelectorAll('[data-caffi-ms]').forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nivelesdelcir"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCaffiBenef = (s) => {
      if (s.dataset.caffiReady === 'true') return;
      s.dataset.caffiReady = 'true';

      const count = parseInt(s.dataset.count, 10) || 3;
      const show = () => {
        s.classList.add('is-visible');
        // Cuando termina la entrada, liberamos los hovers
        setTimeout(() => s.classList.add('is-done'), 1300 + count * 200);
      };

      if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
        s.classList.add('is-visible', 'is-done');
        return;
      }

      s.classList.add('is-ready');
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          show();
          io.disconnect();
        });
      }, { threshold: 0.3 });
      io.observe(s);
    };

    const initAll = () => document.querySelectorAll('[data-caffi-benef]').forEach(initCaffiBenef);

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["queesgrid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCaffiExplainer = (root) => {
      if (root.dataset.caffiExplainerReady === 'true') return;
      root.dataset.caffiExplainerReady = 'true';

      const content = root.querySelector('[data-caffi-reveal]');
      if (!content || !('IntersectionObserver' in window)) {
        if (content) content.classList.add('is-visible');
        return;
      }

      root.classList.add('is-ready');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.16 });

      observer.observe(content);
    };

    const initAllCaffiExplainers = () => {
      document.querySelectorAll('[data-caffi-grind-explainer]').forEach(initCaffiExplainer);
    };

    initAllCaffiExplainers();
    document.addEventListener('shopify:section:load', initAllCaffiExplainers);
  })();

  } catch(e) { console.error(e); }
})();
})();
